module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_5010.2e77bf01.png";